<template>
  <div class="tab-pane fade show active" id="nav-5-3-primary-ver--1" role="tabpanel">
        <!-- Accordion -->
        <span v-on:click="toggleCollapse(collapseStatus)" class="pull-right" style=""><a class="g-font-size-12" v-if="collapseStatus == false">Expand All </a><a class="g-font-size-12" v-if="collapseStatus == true">Collapse All</a></span>
        <h3 class="g-color-main">Resources</h3>
        <div style="background-color: #26304d; height: 3px; margin-bottom: 10px"></div>
        <div v-for="(group, index) in groups" id="accordion-12-1" class="u-accordion u-accordion-color-primary" role="tablist" aria-multiselectable="true">
            <!-- Card -->
            <div class="card g-brd-none rounded-0" :class="{'g-bg-secondary': ((index % 2) == 1)}">
            <div id="accordion-12-1-heading-01" class="u-accordion__header g-color-text g-font-weight-500" role="tab">
                <h5 class="mb-0">
                <a v-on:click="changeCollapse(group)" class="d-block g-color-text g-font-size-20--md g-font-size-17 g-color-primary--hover g-text-underline--none--hover g-pa-12"  data-toggle="collapse" data-parent="#accordion-12-1" aria-expanded="true" aria-controls="accordion-12-1-body-01">
                    {{group.name}}
                </a>
                </h5>
            </div>
            <div v-show="group.open" id="accordion-12-1-body-01" class="collapsed show" role="tabpanel" aria-labelledby="accordion-12-1-heading-01">
                <div class="u-accordion__body g-color-text g-pa-30 g-pt-0">
                <span class="g-font-size-20--md g-font-size-17" v-html="group.items"></span> 
                </div>
            </div>
            </div>
            <!-- End Card -->
        </div>
        <!-- End Accordion -->
    </div>
</template>
<script>
export default {
    data () {
    return {
        collapseStatus: false,
        groups: [
            {
                "name": "How do I use the Resources provided?",
                "open": false,
                "items": "The Resources provided are intended to support your charity work. Resources include key statistics, marketing materials to promote your charity outreach, and specifics on setting up a vision event with downloadable guides, templates, webinars and videos. Materials will be updated quarterly."
            },
            {
                "name": "Where can I provide Resource suggestions or helpful ideas?",
                "open": false,
                "items": "Please make suggestions for additional Resources on the <a href='Resources'>Resources Page</a>. We welcome ideas and best practices. "
            },
            {
                "name": "Do you support with any other Resources such as stock lenses and portable examination equipment?",
                "open": false,
                "items": "Essilor Vision Foundaton provides additional resources such as in-kind stock lenses, rental portable examination equipment (phoropter, tripod, and wallchart), or extra frame collections for vision events. Subject to rental fees and availability."
            },
            {
                "name": "What Resources are available for International charitable efforts?",
                "open": false,
                "items": "Essilor Vision Foundation is committed to offering support for domestic vision initiatives, specifically those focused on children. However, we also offer support for one-time International mission aid for US-based doctors and non-profits. For ongoing International support and relief efforts, please reach out to the following agencies directly supporting International vision services with sustainable resources:" 
                + "<ul>" + "<li><a href='http://vosh.org/' target='_blank'>Volunteer Optometric Services for Humanity (VOSH) International</a></li>" +
                 "<li><a href='http://members.lionsclubs.org/EN/serve/other-ways-to-serve/global-outreach/index.php' target='_blank'>Lions Club International</a></li>" +
                 "<li><a href='http://restoringvision.org/' target='_blank'>Restoring Vision</a></li>" +
                 "<li><a href='https://onesight.org/' target='_blank'>OneSight</a></li>" + 
                 "<li><a href='http://www.givingsight.org' target='_blank'>Optometry Giving Sight</a></li>" +
                 "<li><a href='https://www.essilorindia.com/about-essilor/NVG' target='_blank'>2.5 New Vision Generation</a></li>" + "</ul>"
            }
        ]
    }
    },
    methods: {
        toggleCollapse(collapseStatus) {
            this.collapseStatus = !this.collapseStatus;
            this.groups.forEach(element => {
                element.open = this.collapseStatus;
            });
        }, 
        changeCollapse(group) {
            this.groups.forEach(element => {
                element.open = false;
            });
            group.open = true;
        }
    }
}
</script>



// WEBPACK FOOTER //
// Resources.vue?cc2bd0da